import { DeltaLabel } from '@/shared/components';
import { formatBalance } from '@/shared/lib';
import type { MarketAsset } from '@/widgets/market-assets';
import { SearchCell } from './SearchCell';

type Props = {
  asset: MarketAsset;
  baseAsset: string;
};

const SearchMarketRow = ({ asset, baseAsset }: Props) => (
  <SearchCell
    code={asset.code}
    name={asset.name}
    icon={asset.icon}
    amount={
      <>
        <span className="medium5 text-primary whitespace-nowrap">
          {formatBalance(asset.price, asset.precision)} {baseAsset}
        </span>
        <DeltaLabel
          deltaPercent={asset.deltaPercent}
          size="card"
          showLabelText={false}
          className="gap-0 bg-transparent pl-[0.4rem] pr-0 py-0"
        />
      </>
    }
  />
);

export { SearchMarketRow };
